/**
 * Run-history counts moved off Settings. The counts are the stored runtime proof figures.
 * AI usage gauges stay on the Engine Room AI power section. The usage policy
 * remains a Settings control because it is a write, not a reading.
 */
import type { ReactElement } from 'react';
import type { RuntimeProof } from '../lib/data';

export function EngineRoomRecords({ proofs }: {
  readonly proofs: readonly RuntimeProof[];
}): ReactElement {
  return (
    <section className="engine-room-records stack" aria-label="Engine Room records">
      <section className="stack" aria-label="Run history">
        <h2>Run history</h2>
        <p className="muted">Success, failure, and run counts reported for each computer and runtime. This list does not change a route.</p>
        {proofs.length === 0 ? <p className="muted">No run history counts yet.</p> : (
          <table className="who-does-what-table">
            <thead>
              <tr>
                <th scope="col">Computer</th>
                <th scope="col">Runtime</th>
                <th scope="col">Runs</th>
                <th scope="col">Successes</th>
                <th scope="col">Failures</th>
              </tr>
            </thead>
            <tbody>
              {proofs.map((proof) => (
                <tr key={`${proof.node_id}:${proof.runtime_key}`}>
                  <td>{proof.node_name}</td>
                  <td>{proof.runtime_label?.trim() || proof.runtime_key}</td>
                  <td>{proof.run_count}</td>
                  <td>{proof.success_count}</td>
                  <td>{proof.failure_count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </section>
  );
}
